import BoxUrlOrFile from "@components/BoxUrlOrFile";
import ButtonContainer from "@components/ButtonContainer";
import FileUpload from "@components/Shared/FileUpload";
import FormDatePickerField from "@components/Shared/FormDatePickerField";
import FormTextField from "@components/Shared/FormTextField";
import IFormProps from "@interfaces/Shared/formProps";
import { ReactElement } from "react";
import { Field } from "react-final-form";

const CreateForm = ({ handleSubmit }: IFormProps): ReactElement => (
  <form className="form form--horizontal" onSubmit={handleSubmit}>
    <div className="form__form-group">
      <span className="form__form-group-label">Title</span>
      <div className="form__form-group-field">
        <Field
          name="title"
          component={FormTextField}
          type="text"
          placeholder={"Webinar's Title"}
          isAboveError
        />
      </div>
    </div>

    <div className="form__form-group">
      <span className="form__form-group-label">Date</span>
      <div className="form__form-group-field">
        <Field
          name="date"
          component={FormDatePickerField}
          placeholder="Enter a Date"
          isAboveError
        />
      </div>
    </div>

    <FileUpload title="Thumbnail" isSingle formFieldName="thumbnailUrl" />

    <BoxUrlOrFile title="Media" />

    <ButtonContainer />
  </form>
);

export default CreateForm;
